const FLUX_SYNCUP = [
  {
    id: 'utilisateur-authentification',
    nom: 'Utilisateur -> Authentification',
    objectif: 'Confirmer qu un utilisateur peut etre reconnu et ouvrir une session valide.',
    categorie: 'identite',
    etatInitial: 'non_interprete',
  },
  {
    id: 'utilisateur-roles',
    nom: 'Utilisateur -> Roles',
    objectif: 'Expliquer quels roles effectifs portent les capacites de l utilisateur.',
    categorie: 'autorisation',
    etatInitial: 'non_interprete',
  },
  {
    id: 'utilisateur-scopes',
    nom: 'Utilisateur -> Scopes',
    objectif: 'Expliquer pourquoi une action ou lecture precise est autorisee ou refusee.',
    categorie: 'autorisation',
    etatInitial: 'non_interprete',
  },
  {
    id: 'parent-enfants',
    nom: 'Parent -> Enfants',
    objectif: 'Expliquer pourquoi un parent voit ou ne voit pas un enfant.',
    categorie: 'relation_metier',
    etatInitial: 'inconnu',
    invariants: [
      'parent_utilisateur_actif',
      'enfant_existe',
      'relation_parent_enfant_active',
      'meme_contexte_organisationnel',
      'projection_enfants_visibles_contient_enfant',
    ],
  },
  {
    id: 'joueur-equipe',
    nom: 'Joueur -> Equipe',
    objectif: 'Expliquer pourquoi un joueur appartient ou non a une equipe.',
    categorie: 'relation_metier',
    etatInitial: 'non_interprete',
  },
  {
    id: 'equipe-calendrier',
    nom: 'Equipe -> Calendrier',
    objectif: 'Expliquer pourquoi une equipe voit ou ne voit pas son calendrier.',
    categorie: 'projection',
    etatInitial: 'non_interprete',
  },
  {
    id: 'activite-presences',
    nom: 'Activite -> Presences',
    objectif: 'Expliquer pourquoi une presence peut ou ne peut pas etre consultee ou modifiee.',
    categorie: 'workflow',
    etatInitial: 'non_interprete',
  },
  {
    id: 'utilisateur-canaux',
    nom: 'Utilisateur -> Canaux',
    objectif: 'Expliquer pourquoi un utilisateur voit ou ne voit pas un canal de communication.',
    categorie: 'communication',
    etatInitial: 'non_interprete',
  },
  {
    id: 'canal-messages',
    nom: 'Canal -> Messages',
    objectif: 'Expliquer pourquoi un message peut ou ne peut pas etre envoye ou visible.',
    categorie: 'communication',
    etatInitial: 'non_interprete',
  },
  {
    id: 'notifications',
    nom: 'Notifications',
    objectif: 'Expliquer pourquoi une notification attendue est partie, bloquee, retardee ou absente.',
    categorie: 'communication',
    etatInitial: 'non_interprete',
  },
  {
    id: 'event-store-projections',
    nom: 'Event Store -> Projections',
    objectif: 'Expliquer si les evenements sources produisent les projections visibles attendues.',
    categorie: 'projection',
    etatInitial: 'non_interprete',
  },
];

function obtenirFluxSyncUp(id) {
  return FLUX_SYNCUP.find((flux) => flux.id === id) || null;
}

module.exports = {
  FLUX_SYNCUP,
  obtenirFluxSyncUp,
};



// WEBPACK FOOTER //
// src/components/cockpitSyncUp/catalogueFluxSyncUp.js